export default "__VITE_ASSET__DNHSIXtL__"